import React from 'react';
import loadable from '@loadable/component';
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Loader } from '../../../../common/components';

// Routes
const ListHRScoringParametersPage = loadable(() => import('./ListHRScoringParametersPage'), {
  fallback: <Loader />
});
const AddHRScoringParametersPage = loadable(() => import('./AddHRScoringParametersPage'), {
  fallback: <Loader />
});
const EditHRScoringParametersPage = loadable(() => import('./EditHRScoringParametersPage'), {
  fallback: <Loader />
});
const ViewHRScoringParametersPage = loadable(() => import('./ViewHRScoringParametersPage'), {
  fallback: <Loader />
});

const HRScoringParametersRoute = ({ t, alert }) => {
  return (
    <Routes>
      <Route index exact path="/list" element={<ListHRScoringParametersPage t={t} alert={alert} />} />
      <Route exact path="/add" element={<AddHRScoringParametersPage t={t} alert={alert} />} />
      <Route exact path="/edit/:id" element={<EditHRScoringParametersPage t={t} alert={alert} />} />
      <Route exact path="/view/:id" element={<ViewHRScoringParametersPage t={t} alert={alert} />} />
      <Route path="*" element={<Navigate replace to="/404" />} />
    </Routes>
  );
};
HRScoringParametersRoute.propTypes = {
  t: PropTypes.func
};
export default HRScoringParametersRoute;
